import { render, staticRenderFns } from "./batch_add.vue?vue&type=template&id=1247f484&scoped=true&"
import script from "./batch_add.vue?vue&type=script&lang=js&"
export * from "./batch_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1247f484",
  null
  
)

export default component.exports